<div class="ui-section-header">
  <ng-content select="[ui-section-header-title]"></ng-content>

  <ng-content select="[ui-section-header-text]"></ng-content>
</div>
